<template>
  <main class="app" @click="toggle" :data-loading="loading" :data-shimmer="shimmer">

    <!-- Header -->
    <header class="topbar">
      <div class="logo skel"></div>
      <div class="nav">
        <div class="nav-item skel"></div>
        <div class="nav-item skel"></div>
        <div class="nav-item skel"></div>
      </div>
      <div class="avatar skel"></div>
    </header>

    <!-- Metrics -->
    <section class="metrics">
      <article class="metric-card">
        <div class="metric-label skel"></div>
        <div class="metric-value skel"></div>
      </article>
      <article class="metric-card">
        <div class="metric-label skel"></div>
        <div class="metric-value skel"></div>
      </article>
      <article class="metric-card">
        <div class="metric-label skel"></div>
        <div class="metric-value skel"></div>
      </article>
    </section>

    <!-- Main Layout -->
    <section class="layout">
      <!-- Sidebar -->
      <aside class="sidebar">
        <div class="menu-item skel"></div>
        <div class="menu-item skel"></div>
        <div class="menu-item skel"></div>
        <div class="menu-item skel"></div>
      </aside>

      <!-- Content -->
      <div class="content">

        <!-- Feed -->
        <section class="feed">
          <article class="card">
            <div class="avatar skel"></div>
            <div class="body">
              <div class="line title skel"></div>
              <div class="line skel w-80"></div>
              <div class="line skel w-60"></div>
            </div>
          </article>
          <article class="card clone"></article>
          <article class="card clone"></article>
        </section>

        <!-- Table -->
        <section class="table">
          <div class="row header">
            <div class="cell skel"></div>
            <div class="cell skel"></div>
            <div class="cell skel"></div>
          </div>
          <div class="row">
            <div class="cell skel"></div>
            <div class="cell skel"></div>
            <div class="cell skel"></div>
          </div>
          <div class="row">
            <div class="cell skel"></div>
            <div class="cell skel"></div>
            <div class="cell skel"></div>
          </div>
        </section>

      </div>
    </section>

  </main>
  <div style="margin-top: 10px;text-align: center;padding: 20px;background-color: grey;color: white;border-radius: 10px;">در حال ساخت</div>
</template>
<script setup>
  import { ref } from 'vue'
  const loading = ref(true)
  const shimmer = ref(true)
  function toggle(){
      loading.value = !loading.value;
      shimmer.value = !shimmer.value;
  }
  setTimeout(() => {
    loading.value = false;
  }, 3000);
</script>
<style scoped>
* { box-sizing: border-box; }
.app {
  margin: 0;
  background: #0f1115;
  color: #e6e8ee;
  padding: 5px;
  font-family: system-ui, sans-serif;
}

.skel {
  background: #242836;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}

.app[data-shimmer="true"] .skel::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    transparent 40%,
    #313754 50%,
    transparent 60%
  );
  animation: shimmer 1.4s infinite linear;
}

@keyframes shimmer {
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
}

@media (prefers-reduced-motion: reduce) {
  .skel::after { animation: none; }
}

/* ---------- header ---------- */
.topbar {
  display: grid;
  grid-template-columns: 120px 1fr 40px;
  align-items: center;
  gap: 20px;
}

.logo { width: 120px; height: 24px; }
.nav { display: flex; gap: 16px; }
.nav-item { width: 80px; height: 16px; }
.avatar { width: 40px; height: 40px; border-radius: 50%; }

/* ---------- metrics ---------- */
.metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.metric-card {
  padding: 16px;
  border-radius: 14px;
  background: #171a21;
  border: 1px solid #23263a;
  display: grid;
  gap: 10px;
}

.metric-label { width: 60%; height: 12px; }
.metric-value { width: 40%; height: 22px; }

/* ---------- layout ---------- */
.layout {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
}

.sidebar {
  background: #171a21;
  border: 1px solid #23263a;
  border-radius: 14px;
  padding: 16px;
  display: grid;
  gap: 14px;
}

.menu-item { height: 14px; }

/* ---------- feed ---------- */
.feed {
  display: grid;
  gap: 16px;
}

.card {
  display: grid;
  grid-template-columns: 48px 1fr;
  gap: 14px;
  padding: 16px;
  background: #171a21;
  border: 1px solid #23263a;
  border-radius: 14px;
}

.body {
  display: grid;
  gap: 8px;
}

.line { height: 14px; }
.line.title { height: 18px; width: 60%; }
.w-80 { width: 80%; }
.w-60 { width: 60%; }

/* ---------- table ---------- */
.table {
  margin-top: 24px;
  border: 1px solid #23263a;
  border-radius: 14px;
  overflow: hidden;
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 12px 16px;
  gap: 16px;
  border-bottom: 1px solid #23263a;
}

.row:last-child { border-bottom: none; }

.cell { height: 14px; }

</style>